import React, { useState, useEffect } from 'react';
import { collection, addDoc, updateDoc, doc, Timestamp } from 'firebase/firestore';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { db, storage, auth } from '../Firebase/Firebase';
import Modal from 'react-modal';
import '../Pages/news.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
Modal.setAppElement('#root');

const NewsForm = ({ isOpen, onRequestClose, newsItem }) => {
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [image, setImage] = useState(null);
    const [progress, setProgress] = useState(0);
    const [existingImageUrl, setExistingImageUrl] = useState('');

    useEffect(() => {
        if (newsItem) {
            setTitle(newsItem.title);
            setContent(newsItem.content);
            setExistingImageUrl(newsItem.imageUrl);
        }
    }, [newsItem]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const user = auth.currentUser;

        let imageUrl = existingImageUrl;
        if (image) {
            const storageRef = ref(storage, `images/${image.name}`);
            const uploadTask = uploadBytesResumable(storageRef, image);

            uploadTask.on('state_changed',
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    setProgress(progress);
                },
                (error) => {
                    console.error("Error uploading image: ", error);
                },
                async () => {
                    imageUrl = await getDownloadURL(uploadTask.snapshot.ref);
                    await saveNews(user, imageUrl);
                }
            );
        } else {
            await saveNews(user, imageUrl);
        }
    };

    const saveNews = async (user, imageUrl) => {
        try {
            if (newsItem) {
                const newsRef = doc(db, 'news', newsItem.id);
                await updateDoc(newsRef, {
                    title,
                    content,
                    imageUrl,
                    timestamp: Timestamp.now()
                });
                toast.success("Noticia actualizada con éxito");

            } else {
                await addDoc(collection(db, 'news'), {
                    username: user.displayName,
                    title,
                    content,
                    imageUrl,
                    timestamp: Timestamp.now()
                });
                toast.success("Noticia publicada con éxito");
            }
            setTitle('');
            setContent('');
            setImage(null);
            setProgress(0);
            onRequestClose(); // Cerrar el modal después de guardar
        } catch (error) {
            console.error("Error saving document: ", error);
        }
    };

    return (

        <Modal

            isOpen={isOpen}
            onRequestClose={onRequestClose}
            contentLabel={newsItem ? "Editar Noticia" : "Publicar Noticia"}
            className="modal"
            overlayClassName="overlay"
        >
            <ToastContainer />

            <h2>{newsItem ? "Editar Noticia" : "Publicar Noticia"}</h2>
            <form className="form-news" onSubmit={handleSubmit}>
                <input
                    type="text"
                    placeholder="Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                />
                <textarea
                    placeholder="Content"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    required
                    className="form-news-textarea"
                ></textarea>
                <input
                    type="file"
                    onChange={(e) => setImage(e.target.files[0])}
                />
                {existingImageUrl && !image && (
                    <img src={existingImageUrl} alt="Existing News" style={{ maxWidth: '100%' }} />
                )}
                <button type="submit">{newsItem ? "Actualizar" : "Publicar"}</button>
                {progress > 0 && <progress value={progress} max="100">{progress}%</progress>}
            </form>
            <button onClick={onRequestClose} className="close-btn">Cerrar</button>
        </Modal>

    );
};

export default NewsForm;
